import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_create_report_subscription_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { report: { module_id: string, report_id: string, inputs: any, type: $frontendTypes.Notifications.e_report_file_type }, to: string, cc?: string, bcc?: string, subject: string, body?: string, cron_expression: string }): Promise<{ schedule_name?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.report)) {
      $missingRequiredInParams.push('\'report\'');
    }
    if (isNil($inParams.to)) {
      $missingRequiredInParams.push('\'to\'');
    }
    if (isNil($inParams.subject)) {
      $missingRequiredInParams.push('\'subject\'');
    }
    if (isNil($inParams.cron_expression)) {
      $missingRequiredInParams.push('\'cron_expression\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

